<script>
import Apple from '@/components/svg/Apple'
import GooglePlay from '@/components/svg/GooglePlay'

export default {
  components: { Apple, GooglePlay },
  props: {
    url: { type: String, required: true },
    name: { type: String, required: true },
		icon: { type: String, required: true },
		qrSrc: { type: String, required: true },
  },
}
</script>

<template>
	<a
		:href="url"
		target="_blank"
		class="flex flex-col bg-white overflow-hidden"
		style="padding: 18px; padding-top: 26px; border-radius: 16px;"
	>
		<div class="flex flex-col">
			<span
				class="text-grey text-sm font-medium uppercase leading-none"
				style="letter-spacing: 2.8px;"
			>Get our</span>
			<span
				class="font-inter text-black font-medium leading-none"
				style="font-size: 28px; margin-top: 10px;"
			>{{ name }}</span>
		</div>
		<div class="mt-5 flex justify-between items-end">
			<div
				class="flex justify-center items-center bg-black rounded-full"
				style="width: 50px; height: 50px; flex-shrink: 0;"
			>
				<component
					:is="icon"
					class="text-white"
					style="width: 23px; height: 27px;"
				/>
			</div>
			<img
				:src="qrSrc"
				:alt="`QR code for ${name}`"
				loading="lazy"
				width="75"
				height="75"
				class="ml-5"
			/>
		</div>
	</a>
</template>
